import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ConceptData } from "../types";

export interface ConceptResponse extends ApiResponse {
    data: ConceptData[];
}

export const fetchConcepts = () => {
    return apiClient<ConceptResponse>("/v1/concepts", {
        method: "GET"
    }).then(res => res.data);
}
